import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gcse-help-club',
    templateUrl: './gcse-help-club.component.html',
    styleUrls: ['./gcse-help-club.component.css'],
    standalone: false
})
export class GcseHelpClubComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openForm() {
    window.open('https://zfrmz.in/8nPGUnu1WyRoLcDUWmvh', '_blank');
  }

}
